export default "__VITE_ASSET__97c7d43d__"